import React, { useEffect } from "react";
import { Box, Typography, Button, Stack } from "@mui/joy";
import PodiumImg from "../podium-vector.png";
import "./Bills/Bills.css";

function NotFound() {
  useEffect(() => {
    document.title = "Page Not Found | Civic Engage";
  }, []);

  const goToLegislators = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/legislators");
    const navEvent = new PopStateEvent("popstate");
    window.dispatchEvent(navEvent);
  };

  const goToBills = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/bills");
    const navEvent = new PopStateEvent("popstate");
    window.dispatchEvent(navEvent);
  };

  return (
    <Stack
      className="loading-container"
      direction={"column"}
      padding={2}
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={PodiumImg} alt={"podium decorative"} width="300" height="300" />
      <Box className="loading-title">
        <Typography level="h1" color="primary" sx={{ textAlign: "center" }}>
          Oops! This Page Didn’t Pass the Vote
        </Typography>
        <Typography
          className="not-found"
          level="title-md"
          sx={{ marginTop: 2, textAlign: "center" }}
        >
          Looks like this page didn’t make it through committee. But no
          filibusters here—let’s get you back on track. Let’s find your way back
          to the issues that matter most.
        </Typography>
      </Box>
      <Box className="not-found-buttons">
        <Button
          variant="outlined"
          color="neutral"
          size="lg"
          onClick={goToBills}
          sx={{
            paddingX: 4,
            paddingY: 1.5,
            fontSize: '16px',
            fontWeight: 600,
            borderRadius: '12px',
            borderWidth: '2px',
            borderColor: '#cbd5e1',
            color: '#475569',
            bgcolor: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.2s ease',
            '&:hover': {
              bgcolor: 'white',
              borderColor: '#94a3b8',
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            },
            '@media (prefers-reduced-motion: reduce)': {
              transition: 'none',
              '&:hover': {
                transform: 'none',
              },
            },
          }}
        >
          Explore Legislation
        </Button>
        <Button
          size="lg"
          onClick={goToLegislators}
          sx={{
            bgcolor: '#0052A3',
            paddingX: 4,
            paddingY: 1.5,
            fontSize: '16px',
            fontWeight: 600,
            borderRadius: '12px',
            boxShadow: '0 4px 14px rgba(0, 82, 163, 0.25)',
            transition: 'all 0.2s ease',
            '&:hover': {
              bgcolor: '#003d7a',
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 20px rgba(0, 82, 163, 0.35)',
            },
            '@media (prefers-reduced-motion: reduce)': {
              transition: 'none',
              '&:hover': {
                transform: 'none',
              },
            },
          }}
        >
          Find Your Representative
        </Button>
      </Box>
    </Stack>
  );
}

export default NotFound;
